import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IGeolocationCoordinates } from '../models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GeolocationStore {
  private _geolocationCoordinates$ = new BehaviorSubject<IGeolocationCoordinates | null>(
    null
  );

  readonly geolocationCoordinates$ = this._geolocationCoordinates$.asObservable();

  get geolocationCoordinates(): IGeolocationCoordinates | null {
    return this._geolocationCoordinates$.getValue();
  }

  set geolocationCoordinates(v: IGeolocationCoordinates | null) {
    this._geolocationCoordinates$.next(v);
  }

  private _permissionDenied$ = new BehaviorSubject<boolean>(false);

  readonly permissionDenied$ = this._permissionDenied$.asObservable();

  get permissionDenied(): boolean {
    return this._permissionDenied$.getValue();
  }

  set permissionDenied(v: boolean) {
    this._permissionDenied$.next(v);
  }

  private readonly _isLoadingGeolocation$ = new BehaviorSubject(false);
  readonly isLoadingGeolocation$ = this._isLoadingGeolocation$.asObservable();

  get isLoadingGeolocation(): boolean {
    return this._isLoadingGeolocation$.getValue();
  }

  set isLoadingGeolocation(value: boolean) {
    this._isLoadingGeolocation$.next(value);
  }

  readonly hasCoordinates$: Observable<boolean> = this.geolocationCoordinates$.pipe(
    map((geolocationCoordinates) => !!geolocationCoordinates)
  );

  clear() {
    this._geolocationCoordinates$.next(null);
  }
}
